import {transition} from '@angular/animations';
import {ActionConfirm} from './../../../../../Models/ActionConfirm';
import {TranslateService} from '@ngx-translate/core';
import {Solution} from './../../../../../Models/Solution';
import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {SolutionService} from 'src/app/back-office/Services/solution.service';
import {Subscription} from 'rxjs';
import {Helper} from 'src/app/helpers/helper.service';

@Component({
  selector: 'app-solution-action-confirmation',
  templateUrl: './solution-action-confirmation.component.html',
  styleUrls: ['./solution-action-confirmation.component.scss']
})
export class SolutionActionConfirmationComponent implements OnInit, OnDestroy {
  @Input() Index: number;

  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];
  public solutionStepOptions = [];

  constructor(
    private solutionService: SolutionService,
    public helper: Helper,
    private translator: TranslateService
  ) {
  }

  ngOnInit() {

    this.subscriptions.push(
      this.solutionService.solution.subscribe(solution => {
        this.solution = solution;
        if (this.solution.solutionSteps[this.Index] && !this.solution.solutionSteps[this.Index].actionConfirm) {
          this.solution.solutionSteps[this.Index].actionConfirm = new ActionConfirm();
        }
        this.solutionStepOptions = [];
        this.solution.solutionSteps.forEach((item , index) => {
          if (index <= this.Index) {
            return;
          }
          this.solutionStepOptions.push({value: index, label: this.translator.instant('admin.action_confirm.step') + ' ' + (index + 1)});
        });
        this.solutionStepOptions.push({value: -1, label: this.translator.instant('doctrine.solution.end_step')});
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getActionConfirm() {
    return ActionConfirm;
  }

  updateSolution() {
    this.solutionService.solution.next(this.solution);
  }
}
